import { EventEmitter, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getNotices } from '../../../graph-ql/admin/admin.queries';
import { NoticeDto } from '../../models/admin/notice.dto';

@Injectable({
  providedIn: 'root'
})
export class NoticesService {

  readonly notices: EventEmitter<any> = new EventEmitter();

  constructor(public apollo: Apollo) {

  }

  init(): void {
    this.getNotices();
  }

  getNotices(): void {

    this.apollo.query<NoticeDto[]>({
      query: getNotices
    }).pipe(map(result => {
      const noticesArrayRaw = result.data['getNotices'];

      if (noticesArrayRaw) {
        noticesArrayRaw.map((noticeRaw) => {
          const noticeTemp = new NoticeDto(noticeRaw['level'], noticeRaw['title'], noticeRaw['description'], noticeRaw['infoUrl']);
          noticeTemp.id = noticeRaw.id;
          return noticeTemp;
        });
        return noticesArrayRaw;
      }
    })).subscribe((data) => {
      this.saveNotices(data);

      this.notices.emit(JSON.parse(localStorage.getItem('notices')));
    });

  }

  saveNotices(notices) {
    const noticesOld = JSON.parse(localStorage.getItem('notices'));
    if (!noticesOld) {
      localStorage.setItem('notices', JSON.stringify(notices ? notices : []));
    } else {
      this.markReadNotices(notices);
    }
  }

  readNotices() {
    const noticesOld = JSON.parse(localStorage.getItem('notices'));
    const noticesOldReaded = noticesOld.map((notice: NoticeDto) => {
      notice.readed = true;
      return notice;
    });
    localStorage.setItem('notices', JSON.stringify(noticesOldReaded));
    this.notices.emit(JSON.parse(localStorage.getItem('notices')));
    return noticesOldReaded;
  }

  private markReadNotices(notices: NoticeDto[]) {
    const noticesOld = JSON.parse(localStorage.getItem('notices'));
    const noticesUpdated = [];
    for (const notice of notices) {
      const found = noticesOld.find((noticeOld: NoticeDto) => {
        return noticeOld.id === notice.id;
      });
      if (found) {
        notice.readed = found.readed;
      }
      noticesUpdated.push(notice);
    }
    localStorage.setItem('notices', JSON.stringify(noticesUpdated));
  }

  private addNoticesIfNoExits(notices: NoticeDto[], noticesOld: NoticeDto[]) {
    const noticesToPush = [];
    for (const notice of notices) {
      const foundNotice = noticesOld.find((noticeOld: NoticeDto) => {
        return noticeOld.id === notice.id;
      });
      if (foundNotice) {
        break;
      }
      noticesToPush.push(notice);
    }

    const noticiesToSave = noticesOld.concat(noticesToPush);
    localStorage.setItem('notices', JSON.stringify(noticiesToSave));

  }

}
